;
(function($) {

  $(document).ready(function() {
    initAgeVerify();
  });

  function initAgeVerify(e) {
    if (Cookies.get('ageVerified')) {
      $("#ageverify").hide();

    } else {
      //console.log('no age verified');
      $("#verify-btn").click(function(e) {
        e.preventDefault();
        // long term cookie set
        if ($('input#remember').is(':checked')) {
          window.scrollTo(0, 0);
          Cookies.set('ageVerified', 'ageVerified', {
            expires: 365,
          });
          $("#ageverify").hide();
        } else {
          window.scrollTo(0, 0);
          Cookies.set('ageVerified', 'ageVerified', {
            expires: 30,
          });
          $("#ageverify").hide();
        }
      });
    }
  }

})(jQuery);
